// @ts-nocheck
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import { setupGuard } from './router/guard'
import { createPinia, PiniaVuePlugin } from 'pinia'

import "@/components/index"
import BaiduMap from 'vue-baidu-map'

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.config.productionTip = false

Vue.use(BaiduMap, {
  // ak: 'UON0y2kH9JA79nQIejo4JNFlgfKQya2N'  //这个地方是官方提供的ak密钥
})

setupGuard(router)

new Vue({
  router,
  render: (h) => h(App),
  pinia,
}).$mount("#app")
